var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",attrs:{"href":_vm.tag ==='a' ? _vm.href : false},on:{"mouseover":function($event){_vm.tag = 'a'},"mouseleave":function($event){_vm.tag = 'span'}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }